<template>
  <g>
    <svg
      :id="`circleNode${ arrayIndex }${answer ? `-${answer}` : ''}`"
      :class="`circle-${type} circle-${arrayIndex} circle`"
      :data-answer="answer"
      :width="getRealSize()"
      :height="getRealSize()"
      :x="cx"
      :y="cy"
    >
<!--      <rect-->
<!--        v-if="hasChild === false"-->
<!--        class="circle__rect"-->
<!--        :x="getRealCenterPosition() - radius"-->
<!--        :y="getRealCenterPosition() - radius"-->
<!--        :width="radius * 2"-->
<!--        :height="radius * 2"-->
<!--        stroke-dasharray="5,5"-->
<!--      />-->
      <circle
        class="circle__circle"
        :class="conditionClassName()"
        :cx="getRealCenterPosition()"
        :cy="getRealCenterPosition()"
        :r="radius"
      />
      <text
        class="circle__text"
        :class="conditionClassName()"
        x="50%"
        y="50%"
        dominant-baseline="central"
        text-anchor="middle"
        pointer-events="none"
      >
        {{ text }}
      </text>
    </svg>
  </g>
</template>

<script>
// import * as d3 from 'd3'

export default {
  name: 'CustomCircle',
  props: [
    'radius',
    'text',
    'cx',
    'cy',
    'backgroundColor',
    'textColor',
    'strokeColor',
    'arrayIndex',
    'answer',
    'type',
    'hasChild'
  ],
  data: () => (
    {
      fontSize: 12,
      strokeWidth: 1.6
    }
  ),
  mounted() {
    this.load()
  },
  methods: {
    load() {},
    getRealSize() {
      return (this.radius + this.strokeWidth) * 2
    },
    getRealCenterPosition() {
      return this.radius + this.strokeWidth
    },
    conditionClassName() {
      const text = this.text.toLowerCase()
      return ['yes', 'no'].includes(text) ? `is-${text}` : ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/_variables";

$text-color: #363a48;

$condition-yes-color: #37c38f;
$condition-yes-text-color: #24825e;

$condition-no-color: #eb0751;
$condition-no-text-color: #eb0751;

svg text {
  cursor: pointer;
}

.circle {
  $block: &;

  cursor: pointer;
  fill: #fff;

  &__text {
    font-size: 16px;
    stroke: $stroke-line-color;
    fill: $stroke-line-color;
  }

  &__circle {
    stroke: $stroke-line-color;
    stroke-width: 2;
    cursor: pointer;
  }

  &-add {
    stroke: $stroke-color;
  }

  &-condition {
    stroke-width: 1.5;

    #{$block}__circle {
      cursor: initial !important;
    }

    #{$block}__text {
      font-weight: 800;

      &.is-yes {
        stroke: none;
        fill: $condition-yes-color;
      }

      &.is-no {
        stroke: none;
        fill: $condition-no-color;
      }
    }

    #{$block}__circle {
      &.is-yes {
        stroke: $condition-yes-color;
      }

      &.is-no {
        stroke: $condition-no-color;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomCircle.vue